import React, { useState } from "react"
import moment from "moment"
import NumberFormat from "../../../utils/numberFormat"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setFilter } from "../../../store/actions"

const SoaTable = ({
  data,
  pagination,
  onPageChange,
  hidePagination = false,
  activeTab = "receivable",
  isLoading = false,
  position = false,
  currFormat,
  agingCheck = false,
  ageingPeriod,
  setSkeletonLoading = false,
  balanceData = {},
  dates = {},
}) => {
  const { startDate, endDate } = dates
  const handlePageChange = page => {
    if (onPageChange) {
      onPageChange(page)
    }
  }
  const dispatch = useDispatch()
  const [openLedgerId, setOpenLedgerId] = useState(null)
  const navigate = useNavigate()

  const desimalrange = localStorage.getItem("desimalrange")
  // Modified to handle both credit and debit values
  const calculateAmount = (partialPayments, field) => {
    if (!partialPayments) return 0

    console.log(`partialPayments j`, partialPayments, field)

    return partialPayments.reduce((sum, payment) => {
      if (payment.type === "debit") {
        return Number(sum) + Number(payment[field] ?? 0)
      } else if (payment.type === "credit") {
        return sum - Number(payment[field] ?? 0)
      }
      return sum
    }, 0)
  }

  // Format amount with DR/CR suffix
  const formatAmountWithSuffix = amount => {
    if (
      amount === 0 ||
      amount === null ||
      amount === undefined ||
      amount === "" ||
      amount === "NaN"
    )
      return NumberFormat(0, desimalrange || 2, desimalrange || 2)

    if (amount < 0) {
      return `${NumberFormat(
        Math.abs(amount),
        desimalrange || 2,
        desimalrange || 2
      )} CR`
    } else {
      return `${NumberFormat(amount, desimalrange || 2, desimalrange || 2)} DR`
    }
  }

  const renderPagination = () => {
    const pagesToShow = []
    const totalPages = pagination?.last_page || 1
    const currentPage = pagination?.current_page || 1

    if (totalPages < 7) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i)
      }
    } else {
      if (
        currentPage % 5 >= 0 &&
        currentPage > 4 &&
        currentPage + 2 < totalPages
      ) {
        pagesToShow.push(
          1,
          currentPage - 1,
          currentPage,
          currentPage + 1,
          totalPages
        )
      } else if (
        currentPage % 5 >= 0 &&
        currentPage > 4 &&
        currentPage + 2 >= totalPages
      ) {
        pagesToShow.push(
          1,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        )
      } else {
        pagesToShow.push(1, 2, 3, 4, 5, totalPages)
      }
    }

    return (
      <span>
        {pagesToShow.map((page, index) => (
          <span key={index} onClick={() => handlePageChange(page)}>
            {pagesToShow[index - 1] + 2 < page ? (
              <span>
                <button className={`${currentPage === page ? "active" : ""}`}>
                  ...
                </button>
                <button className={`${currentPage === page ? "active" : ""}`}>
                  {page}
                </button>
              </span>
            ) : (
              <button className={`${currentPage === page ? "active" : ""}`}>
                {page}
              </button>
            )}
          </span>
        ))}
      </span>
    )
  }

  return (
    <div className="soa-table-container">
      <table className="table soa-table fs-12 padding-15">
        <thead className="need-to-be-a-sticky">
          <tr>
            <th style={{ color: "#4B80EE", width: "220px" }}>
              Party's Name (Ref)
            </th>
            {currFormat != 1 && <th></th>}
            {currFormat != 1 && (
              <th className="styles-custom" style={{ color: "#4B80EE" }}>
                Doc Num
              </th>
            )}
            {currFormat != 1 && (
              <th className="styles-custom" style={{ color: "#4B80EE" }}>
                Doc Type
              </th>
            )}
            {/* <th className="styles-custom" style={{ color: "#4B80EE" }}>
              Doc Num
            </th> */}
            {currFormat != 1 && (
              <th className="styles-custom" style={{ color: "#4B80EE" }}>
                Date
              </th>
            )}
            <th
              className="text-end"
              style={{ color: "#4B80EE", width: "140px" }}
            >
              Bill Amount
            </th>
            {/* <th className="text-end" style={{ color: "#4B80EE" }}>
              Paid Amount
            </th> */}
            <th className="text-end" style={{ color: "#4B80EE" }}>
              Pending Amount
            </th>
            {agingCheck && ageingPeriod?.length ? (
              <>
                {ageingPeriod.map((period, index) => (
                  <>
                    <th className="text-end" style={{ color: "#4B80EE" }}>
                      {period?.from_days == 0
                        ? `< ${period?.to_days} Days`
                        : period?.to_days == 0
                        ? `> ${period?.from_days} Days`
                        : `${period?.from_days} to ${period?.to_days} Days`}
                    </th>
                  </>
                ))}
              </>
            ) : (
              <></>
            )}

            {currFormat != 1 && (
              <th className="text-end" style={{ color: "#4B80EE" }}>
                Due Date
              </th>
            )}
            {currFormat == 2 && (
              <th className="text-end" style={{ color: "#4B80EE" }}>
                Over due days
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {(setSkeletonLoading &&
            (pagination == undefined || pagination?.current_page < 1)) ||
          (data?.length === 0 && setSkeletonLoading) ? (
            <>
              {[...Array(8)].map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {[...Array(1)].map((_, colIndex) => (
                    <td key={colIndex} colSpan="9" className="py-2">
                      <div
                        className="skeleton skeleton-text"
                        style={{ width: "100%" }}
                      ></div>
                    </td>
                  ))}
                </tr>
              ))}
            </>
          ) : data?.length === 0 ? (
            <tr>
              <td colSpan="9" className="text-center py-4">
                No Data Found
              </td>
            </tr>
          ) : (
            data?.map(ledger => (
              <React.Fragment key={ledger.ledger_id}>
                {/* Main Ledger Row - Show only ledger name */}
                <tr
                  className="main-row"
                  onClick={
                    currFormat != 1
                      ? () => {
                          setOpenLedgerId(
                            openLedgerId === ledger.ledger_id
                              ? null
                              : ledger.ledger_id
                          )
                          dispatch(
                            setFilter({ dateFrom: startDate, dateTo: endDate })
                          )
                        }
                      : undefined
                  }
                >
                  <td
                    colSpan={currFormat != 1 ? 3 : undefined}
                    style={
                      currFormat != 1
                        ? { width: "300px", wordBreak: "break-word" }
                        : { width: "600px" }
                    }
                    className="fw-bold"
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {/* {currFormat != 1 && (
                        <span
                          style={{
                            display: "inline-flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "20px",
                            height: "20px",
                            marginRight: "8px",
                            borderRadius: "4px",
                            color: "#4B80EE",
                            fontWeight: "bold",
                          }}
                        >
                          {openLedgerId === ledger.ledger_id ? "-" : "+"}
                        </span>
                      )} */}
                      <div>{ledger.ledger_name}</div>
                    </div>
                  </td>
                  {currFormat != 1 && (
                    <td className="text-end" style={{ width: "140px" }}>
                      {/* {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "total_pending_amount"
                      )
                    )} */}
                    </td>
                  )}
                  {currFormat != 1 && (
                    <td className="text-end" style={{ width: "140px" }}>
                      {/* {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "total_pending_amount"
                      )
                    )} */}
                    </td>
                  )}

                  {/* <td className="text-end"> */}
                  {/* {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "pending_less_than_30_days"
                      )
                    )} */}
                  {/* </td> */}
                  <td className="text-end fw-bold">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "total"
                      )
                    )}
                  </td>
                  <td className="text-end fw-bold">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "total_pending_amount"
                      )
                    )}
                  </td>
                  {/* <td></td> */}
                  {agingCheck && ageingPeriod?.length ? (
                    <>
                      {/* {ageingPeriod.map((period, index) => (
                        <>
                          <td></td>
                        </>
                      ))} */}
                      {ageingPeriod.map((period, index) => {
                        const field =
                          period?.to_days == 0
                            ? `pending_over_${period?.from_days}_days`
                            : `pending_${period?.from_days}_to_${period?.to_days}_days`

                        return (
                          <td key={index} className="text-end">
                            {formatAmountWithSuffix(
                              calculateAmount(
                                ledger.voucher_entries?.flatMap(
                                  v => v.partial_payments
                                ),
                                field
                              )
                              // calculateAmount(
                              //   voucher.partial_payments,
                              //   field
                              // )
                            ) || 0}
                          </td>
                        )
                      })}
                    </>
                  ) : (
                    <></>
                  )}
                  {currFormat != 1 && <td className="text-end"></td>}

                  {/* {currFormat == 3 && (
                    <>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </>
                  )} */}
                  {currFormat == 2 && <td className="text-end"></td>}
                </tr>

                {currFormat != 1 && (
                  <>
                    {ledger.voucher_entries?.map((voucher, index) => (
                      <React.Fragment key={voucher.voucher_id}>
                        <tr className="voucher-row">
                          {voucher?.voucher_type == "Opening Balance" ? (
                            <td style={{ paddingLeft: "40px" }}>
                              {currFormat == 2 ? (
                                <>
                                  {NumberFormat(
                                    Number(
                                      voucher?.partial_payments[0]?.total ?? 0
                                    ),
                                    desimalrange || 2,
                                    desimalrange || 2
                                  ) !=
                                  NumberFormat(
                                    Number(
                                      voucher?.partial_payments[0]
                                        ?.total_pending_amount ?? 0
                                    ),
                                    desimalrange || 2,
                                    desimalrange || 2
                                  ) ? (
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "20px",
                                        height: "20px",
                                        marginRight: "8px",
                                        borderRadius: "4px",
                                        color: "#4B80EE",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setOpenLedgerId(
                                          openLedgerId === voucher.voucher_id
                                            ? null
                                            : voucher.voucher_id
                                        )
                                        dispatch(
                                          setFilter({
                                            dateFrom: startDate,
                                            dateTo: endDate,
                                          })
                                        )
                                      }}
                                    >
                                      {openLedgerId === voucher.voucher_id
                                        ? "-"
                                        : "+"}
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                              <span>
                                {voucher?.ref_code
                                  ? voucher?.ref_code
                                  : voucher?.voucher_code}
                              </span>
                            </td>
                          ) : (
                            <td
                              className="pointer"
                              style={{ paddingLeft: "40px", color: "#4B80EE" }}
                            >
                              {currFormat == 2 ? (
                                <>
                                  {NumberFormat(
                                    Number(
                                      voucher?.partial_payments[0]?.total ?? 0
                                    ),
                                    desimalrange || 2,
                                    desimalrange || 2
                                  ) !=
                                  NumberFormat(
                                    Number(
                                      voucher?.partial_payments[0]
                                        ?.total_pending_amount ?? 0
                                    ),
                                    desimalrange || 2,
                                    desimalrange || 2
                                  ) ? (
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "20px",
                                        height: "20px",
                                        marginRight: "8px",
                                        borderRadius: "4px",
                                        color: "#4B80EE",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setOpenLedgerId(
                                          openLedgerId === voucher.voucher_id
                                            ? null
                                            : voucher.voucher_id
                                        )
                                        dispatch(
                                          setFilter({
                                            dateFrom: startDate,
                                            dateTo: endDate,
                                          })
                                        )
                                      }}
                                    >
                                      {openLedgerId === voucher.voucher_id
                                        ? "-"
                                        : "+"}
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                              <span
                                onClick={() => {
                                  navigate(
                                    `/finance-voucher/view/${voucher.voucher_id}`
                                  )
                                  dispatch(
                                    setFilter({
                                      dateFrom: startDate,
                                      dateTo: endDate,
                                    })
                                  )
                                }}
                              >
                                {voucher?.ref_code
                                  ? voucher?.ref_code
                                  : voucher?.voucher_code}
                              </span>{" "}
                              <span className="text-dark fs-8">(New Ref)</span>
                              {/* {voucher.voucher_code} */}
                            </td>
                          )}
                          <td></td>
                          <td>
                            {voucher?.ref_code ? "" : voucher?.voucher_code}
                          </td>
                          <td>{voucher?.voucher_type}</td>
                          <td>
                            {moment(
                              voucher?.ref_date
                                ? voucher?.ref_date
                                : voucher.voucher_date
                            ).format("DD-MMM-YYYY")}
                          </td>
                          <td className="text-end">
                            {NumberFormat(
                              Number(voucher?.partial_payments[0]?.total ?? 0),
                              desimalrange || 2,
                              desimalrange || 2
                            )}{" "}
                            {voucher?.partial_payments[0]?.type === "debit"
                              ? "DR"
                              : "CR"}
                          </td>

                          <td className="text-end">
                            {NumberFormat(
                              Number(
                                voucher?.partial_payments[0]
                                  ?.total_pending_amount ?? 0
                              ),
                              desimalrange || 2,
                              desimalrange || 2
                            )}{" "}
                            {voucher?.partial_payments[0]?.type === "debit"
                              ? "DR"
                              : "CR"}
                          </td>

                          {agingCheck && ageingPeriod?.length ? (
                            <>
                              {ageingPeriod.map((period, index) => {
                                const field =
                                  period?.to_days == 0
                                    ? `pending_over_${period?.from_days}_days`
                                    : `pending_${period?.from_days}_to_${period?.to_days}_days`

                                return (
                                  <td key={index} className="text-end">
                                    {formatAmountWithSuffix(
                                      calculateAmount(
                                        voucher.partial_payments,
                                        field
                                      )
                                    ) || 0}
                                  </td>
                                )
                              })}
                            </>
                          ) : (
                            <></>
                          )}

                          <td className="text-end">
                            {moment(
                              voucher?.partial_payments[0]?.due_date
                            ).format("DD-MMM-YYYY")}
                          </td>
                          {currFormat != 3 && (
                            <td className="text-end">
                              {moment(
                                voucher?.partial_payments[0]?.due_date
                              ).diff(moment(), "days")}
                            </td>
                          )}
                        </tr>
                        {currFormat == 2 &&
                        openLedgerId === voucher.voucher_id ? (
                          <>
                            {voucher?.partial_payments[0]?.against_payments?.map(
                              (partial, index) => (
                                <tr className="voucher-row" key={index}>
                                  <td
                                    className="pointer"
                                    style={{
                                      paddingLeft: "80px",
                                      color: "#4B80EE",
                                    }}
                                    onClick={() => {
                                      navigate(
                                        `/finance-voucher/view/${partial.voucher_id}`
                                      )
                                      dispatch(
                                        setFilter({
                                          dateFrom: startDate,
                                          dateTo: endDate,
                                        })
                                      )
                                    }}
                                  >
                                    {/* {partial?.voucher?.ref_number} */}
                                    {voucher?.ref_code
                                      ? voucher?.ref_code
                                      : voucher?.voucher_code}
                                    <span className="text-dark fs-8">
                                      (Against Ref)
                                    </span>
                                  </td>
                                  <td></td>

                                  <td
                                  // style={{
                                  //   paddingLeft: "80px",
                                  // }}
                                  >
                                    {partial?.voucher?.ref_number
                                      ? partial?.voucher?.ref_number
                                      : ""}
                                  </td>
                                  <td
                                  // style={{
                                  //   paddingLeft: "80px",
                                  // }}
                                  >
                                    {
                                      partial?.voucher?.voucher_type
                                        ?.voucher_type
                                    }
                                  </td>
                                  <td>
                                    {/* {moment(partial?.date).format("DD-MMM-YYYY")}{" "} */}
                                    {moment(partial?.voucher?.date).format(
                                      "DD-MMM-YYYY"
                                    )}{" "}
                                  </td>

                                  <td className="text-end">
                                    {partial?.amount}{" "}
                                    {partial?.credit_debit === "debit"
                                      ? "DR"
                                      : "CR"}
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              )
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </React.Fragment>
                    ))}
                  </>
                )}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>

      {isLoading ? (
        <div class="loader-row">
          <div
            class={`bouncing-loader ${
              position ? "position-of" : "position-out"
            }`}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : pagination?.last_page > 1 ? (
        <div className="d-flex justify-content-center">End of List</div>
      ) : (
        <></>
      )}

      {/* Updated Pagination */}
      {pagination?.total && pagination.total > 16 && !hidePagination ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="my-2 pagination-details"
        >
          <div className="showing-page">
            Showing {pagination.from}-{pagination.to} from {pagination.total}
          </div>
          <div>
            <button
              type="button"
              className="left-pagination-button"
              disabled={pagination.current_page === 1}
              onClick={() => handlePageChange(pagination.current_page - 1)}
            >
              {/* <img
                src={pagination.current_page === 1 ? LeftArrow : redLeftArrow}
                alt="Left Arrow"
              />{" "} */}
              Back
            </button>

            <span>{renderPagination()}</span>
            <button
              type="button"
              className="right-pagination-button"
              disabled={pagination.current_page === pagination.last_page}
              onClick={() => handlePageChange(pagination.current_page + 1)}
            >
              Next{" "}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default SoaTable
